import GroupDiscussionsPage from './GroupDiscussionPage';

export default GroupDiscussionsPage;
